import { openCallablePdf } from '@/services/callablePdfService';

export async function openLearnerCaseRecord(schoolId, studentId) {
  if (!schoolId) throw new Error('schoolId is required');
  if (!studentId) throw new Error('studentId is required');

  return openCallablePdf({
    functionName: 'getLearnerCaseRecord',
    payload: { schoolId, studentId },
    preparingTitle: 'Preparing learner case record…',
    fallbackFilename: 'learner-case-record.pdf',
  });
}
